import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

type TrackBidRetractedPayload = TrackingPayload;

export const trackBidRetractedAnalytics = (payload: TrackBidRetractedPayload) => {
    track(TrackingEvents.Bidding.BidRetracted, payload);
};
